import * as React from "react";
import { Faq as Faq$1, FaqItem } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
import { parseBloomreachContent } from "../../../../hooks/helpers/hooks/helpers/helpers.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
const CmsFaqItem = withEditableContent(({ content }) => {
  const { name, question, answer } = content;
  return /* @__PURE__ */ React.createElement(FaqItem, { id: name, question, answer: answer.value });
});
const CmsFaq = ({ page, content }) => {
  const { name, title, faqItems } = content;
  const items = faqItems?.map((item) => {
    const document = page?.getContent(item);
    const content2 = parseBloomreachContent(document?.getData());
    return { ...content2, document };
  }) ?? [];
  const ids = items.map((item) => item?.name ?? "");
  return /* @__PURE__ */ React.createElement(Faq$1, { name, title, ids }, items.map((item, i) => item && /* @__PURE__ */ React.createElement(CmsFaqItem, { key: `${i}-${item.id}`, content: item })));
};
const Faq = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withAnchor
)(CmsFaq);
export {
  CmsFaq,
  CmsFaqItem,
  Faq as default
};
//# sourceMappingURL=Faq.js.map
